import React, { useState } from "react";

import { useLazyQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { INVOICES } from "shared/graphql/queries";
import { RECEIPT_LINES } from "shared/graphql/receiptLine/queries";
import { PATHS } from "utils/constants";
import useLoadMoreQuery from "utils/hooks/useLoadMoreQuery";

import View from "./View";

const Component = ({ setActiveStep, onChange }) => {
  const history = useHistory();
  const [filter, setFilter] = useState({ where: {} });

  const { query, onLoadMore } = useLoadMoreQuery({
    queryName: INVOICES,
    type: "invoices",
    filter,
    fetchPolicy: "no-cache",
  });

  const [getProducts, recipientLineQuery] = useLazyQuery(RECEIPT_LINES);

  const onNavigate = (folderNumber) => () => {
    history.push(PATHS.FILE.ADVANCEMENT.replace(":id", folderNumber));
  };

  return (
    <View
      onChange={onChange}
      setActiveStep={setActiveStep}
      setFilter={setFilter}
      onLoadMore={onLoadMore}
      query={query}
      getProducts={getProducts}
      recipientLineQuery={recipientLineQuery}
      onNavigate={onNavigate}
    />
  );
};

Component.propTypes = {
  onChange: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
};

Component.defaultProps = {};

export default Component;
